export default __webpack_public_path__ + "static/media/Dot Pattern 4.7efc6c84.svg";